import React from 'react'

import { NavLink } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const FacilityBasicInfoNavLinks = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	let inBooking = location?.pathname?.includes('facilityBooking')
	let inTraining = location?.pathname?.includes('training')

	const getNavItem = (path) => {
		let type
		if (path.includes('daycare')) path = 'Daycare'
		if (path.includes('boarding')) path = 'Boarding'
		if (path.includes('compatibility')) path = 'Compatibility Session'
		if (path.includes('grooming')) path = 'Grooming'
		if (path.includes('training')) path = 'Training'
		return (
			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
				{path}
			</NavLink>
		)
	}

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>
			<NavLink
				className={clsx([classes.crumb, inBooking || inTraining ? {} : classes.selectedCrumb])}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/basicInfo`}>
				Facility Setup{(inBooking || inTraining) && ' /'}
			</NavLink>
			{(inBooking || inTraining) && getNavItem(location.pathname)}
		</div>
	)
}

export default FacilityBasicInfoNavLinks
